import { Box } from '@mui/material';
import Countdown from 'react-countdown';
import { useRouter } from 'next/router';
import SpecialBtn from '../Mint/SpecialBtn';
import CountDown from "../Mint/CountDownSmall";

// Dragon card
export default function DragonCard(props: any) {
    const router = useRouter();

    //
    function clickOnDragon(dragon: any) {
        router.push(`/dragon/${dragon.mint}`)
    }

    function dragonClickHandler() {
        window.open(`https://dragon.eternaldragons.com/${props.dragon.mint}.png`, '_blank');
    }

    //
    function revealCountdownRenderer(data: any, dragon: any) {
        if (data.completed) {
            return (
                <>
                    {eggUi()}

                    <SpecialBtn label="Reveal"
                        width="150px"
                        height="33px"
                        labelSize="15px"
                        variant="blue"
                        textColor="#2c1e13"
                        inProg={props.revealNft?.mint === dragon.mint && props.postRevealInProg}
                        onClick={() => { props.doReveal(dragon) }} disabled={false}
                    />
                </>
            );
        } else {
            return (<Box className="mint-info-box">
                {eggUi()}

                <CountDown days={data.days} hours={data.hours} minutes={data.minutes} seconds={data.seconds} />
            </Box>)
        }
    }

    //
    function placeholderUi() {
        return (
            <>
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    marginBottom: "10px"
                }}>
                    <img src="/mint/Ornament_Egg_Inventory.png"
                        style={{
                            width: "170px",
                            height: "211px",
                            padding: "10px"
                        }} />
                </Box>

                <SpecialBtn
                    label=""
                    variant="gold"
                    disabled={true}
                    width="150px"
                    height="33px"
                    labelSize="15px"
                    inProg={false}
                />
            </>
        )
    }

    // 
    function eggUi() {
        return (
            <>
                <Box sx={{ margin: "0px 0px 5px 0px", fontSize: "15px", color: "#cfbca1", fontWeight: 700 }}>
                    {props.dragon.name}
                </Box>

                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    marginBottom: "10px"
                }}>
                    <img src={props.dragon.image}
                        style={{
                            width: "211px",
                            height: "211px",
                            padding: "12px"
                        }} />
                </Box>
            </>
        )
    }

    //
    function dragonUi() {
        return (
            <>
                <Box sx={{ margin: "0px 0px 5px 0px", fontSize: "15px", color: "#cfbca1", fontWeight: 700 }}>
                    {props.dragon.name}
                </Box>

                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    marginBottom: "10px",
                    cursor: "pointer"
                }}
                    onClick={dragonClickHandler}
                >
                    <img src={"/mint/Frame_" + (props.dragon.score ? props.dragon.score.label : "Common") + ".png"} style={{ width: "200px", height: "211px" }} />

                    <img src={props.dragon.image}
                        style={{
                            position: "absolute",
                            width: "186px",
                            height: "186px",
                            top: "11px",
                        }} />
                </Box>

                <SpecialBtn label="Details"
                    variant="gold"
                    width="150px"
                    height="33px"
                    labelSize="15px"
                    textColor="#2c1e13"
                    inProg={false}
                    onClick={() => { clickOnDragon(props.dragon) }} disabled={false}
                />
            </>
        )
    }

    //
    function revealUi() {
        return (
            <Countdown
                date={props.dragon.revealWaitDate}
                key={props.dragon.revealWaitDate}
                renderer={(cdData) => revealCountdownRenderer(cdData, props.dragon)}
            />
        )
    }

    //
    return (
        <Box key={props.dragon}
            sx={{
                margin: "20px 10px 20px 10px",
                width: "220px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "relative"
            }}>

            {!props.dragon.placeholder &&
                <>
                    {props.dragon.name.startsWith("Eternal Dragon Egg") === true &&
                        <>
                            {props.mode === 'my_gallery' ? revealUi() : eggUi()}
                        </>
                    }

                    {props.dragon.name.startsWith("Eternal Dragon Egg") === false && dragonUi()}
                </>}

            {props.dragon.placeholder && placeholderUi()}
        </Box>
    );
}